var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgQuestionDark = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 18,
  height: 18,
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 9,
  cy: 9,
  r: 9,
  fill: "#333333"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8.09829 10.9704H9.35314L9.47657 10.2916C10.6594 10.0036 11.5646 9.43785 11.5646 8.09042V8.06985C11.5646 6.671 10.4743 5.82757 8.91086 5.82757C7.69714 5.82757 6.81257 6.30071 6.16457 6.959L7.224 8.29614C7.728 7.84357 8.27314 7.58643 8.78743 7.58643C9.32229 7.58643 9.63086 7.823 9.63086 8.20357V8.22414C9.63086 8.70757 9.17829 9.01614 7.91314 9.10871L7.83086 9.191L8.09829 10.9704ZM7.67657 13.4287H9.71314V11.6287H7.67657V13.4287Z",
  fill: "white"
})));
export default SvgQuestionDark;